import { getNumberFromLocalStorage, homeUrl, ONE_DAY, ONE_HOUR } from "./common_utils";
import {getJsonDataPostRequest} from "./network_utils"
import PosthogService from "./tracking_utils";

/** returns -1 or last fetched server time
 * - server time can be upto 12 hours old
 */
export function getCurrentServerTime(){
  return getNumberFromLocalStorage("currentServerTime",-1)
}

export function isValidUser(user){
    if(!user) return false
    return user && user.userId && user.userId>0 && 
            user.email && user.email.length>=5
}

/** saves user to localstorage */
export function saveUser(user){
    if(isValidUser(user)){
        localStorage.setItem("user", JSON.stringify(user));
       // PosthogService.identify(user)
    }

}

/** fetches user object from local storage */
export function getUser(){
    var user = localStorage.getItem("user")
    if(user==null || !user) return null
    let userObj= JSON.parse(user)
    // testing payments ui by changing parameters
   // userObj.creationDate=getCurrentServerTime()-4*ONE_DAY-1000
   
   // uncomment below line to show user is not a premium user
   // userObj.paymentValidTill=100  // 1744550103875
    return userObj
}

export function getAuth(){
    /*if(true){
        return {
            userId:1, 
            secretKey: "abcd", 
            type:0
        }
    }*/
    var user=getUser()
    if(!isValidUser(user)) return {}
    return {
        userId:user.userId, 
        secretKey: user.secretKey, 
        type:0
    }
}

export function isLoggedIn(){
   var auth = getAuth()
   return auth && auth.secretKey && auth.userId 
}


/** 
 * This function will be used in case of premium content
* I need to update UI state when data from backend is fetched
* UI state is 0, 1, 2 and 3, 
* 0 : user not logged in, 
* 1 : user logged in but not a premium user and its their first week
* 2: user is not premium and has been there for more than a week
* 3: premium user
*/
export function getUIState(){
    try{
      if(!isLoggedIn()) return 0;
      let serverTime= getCurrentServerTime()
      let user=getUser()
      // if user is a premium user
      if(user.paymentValidTill>serverTime) return 3;
      // if user is not a premium user and 
      // account was created less than 1 week ago
      if(serverTime-user.creationDate<7*ONE_DAY) return 1;
      else return 2;
    }catch(exception){
      console.log("error in getting UI state "+exception)
    }
    return 0;
  }

  
export function isPremiumUser(){
  try{
  if(!isLoggedIn()) return false;
  let user=getUser();
  let serverTime=getCurrentServerTime();
  if(!serverTime || serverTime==null || serverTime<=10)
   return false;
  if(serverTime<user.paymentValidTill && user.interviewCreditsLeft && user.interviewCreditsLeft>0) return true;
  }catch(exception){
      console.log("exception occurred "+exception);
  }
  return false;
}

  
/**
 * fetches user details and server time every 12 hours or so
 *  for logged in users and also refreshes payment discount details from backend
 */
export function refreshHomePageDetails(mustFetch=false, callback=(data)=>{}){
  try{
      if(!isLoggedIn()) return
      let url = homeUrl()+"authApi/getHomePageDetails";
      let lastFetchTime=getNumberFromLocalStorage("lastFetchTime",0)
      // fetch every 6 hours
      if(!mustFetch && Date.now()-lastFetchTime<=6*ONE_HOUR) return
      getJsonDataPostRequest(url, getAuth(), function(response){
          if(response==null||response.status>=400){
            callback({status:500})
           return     
          }
          saveCommonData(response) 
          if(callback) callback(response)
      })
  }catch(exception){
      console.log("exception occured in refreshing home page details "+ exception)
  }
}

/**
 *  saves User and currentServerTime and updates lastFetchTime 
 */
export function saveCommonData(data){
  saveUserAccountData(data)
  saveCurrentServerTime(data) 
  localStorage.setItem("lastFetchTime",""+Date.now())  
}

/**
 * saves user account data if it is inside the field data.user
 */
export function saveUserAccountData(data){
  if(!data) return
  console.log(data)
  if(data.user && isValidUser(data.user)) saveUser(data.user)
}

/**
 * saves current server time if its there inside the response object
 * in field data.currentServerTime
 * most response objects from backend contains server time.
 */
export function saveCurrentServerTime(data){
  if(data==null || !data || !data.currentServerTime || data.currentServerTime<=0) return
  localStorage.setItem("currentServerTime",""+data.currentServerTime)
}